import { ScoreCardResultsService } from 'api-clients/monolith/services/ScoreCardResultsService';
import { useCallback } from 'react';

import { useApiService } from 'hooks/useApiService';

export const useScorecardResults = (
  templateId: number,
  applicantId: string,
) => {
  const fetchResults = useCallback(
    () =>
      ScoreCardResultsService.getInternalApiScoreCardsTemplatesApplicantsResults(
        templateId,
        applicantId,
      ),
    [templateId, applicantId],
  );

  return useApiService(fetchResults, {
    enabled: Number.isFinite(templateId) && Boolean(applicantId),
  });
};
